import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePermissions } from '../../context/PermissionsContext';

export default function PermissionRoute({ permissionKey, children }) {
  const { permissions } = usePermissions();
  const location = useLocation();

  const hasPermission = (key) => {
    if (!key) return true;
    if (Array.isArray(key)) {
      return key.every((perm) => Boolean(permissions[perm]));
    }
    return Boolean(permissions[key]);
  };

  if (hasPermission(permissionKey)) {
    return children;
  }

  return <Navigate to="/admin/unauthorized" replace state={{ from: location }} />;
}
